import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const toolbarStyle = makeStyles((theme: Theme) =>
  createStyles({
    disableToolbarButton: {
      color: theme.customColors.disableTitle + " !important",
      pointerEvents: "none",
      opacity: "0.5",
    },
    toolbarIcon: {
      backgroundColor: theme.customColors.childBack + " !important",
      color: theme.customColors.title + " !important",
      borderRadius: "20px",
      padding: "5px",
      width: "34px !important",
      height: "34px !important",
    },
    toolbarIconRes: {
      color: theme.customColors.childBack + " !important",
      fontSize: "25px !important",
    },
    toolbarContainerTop: {
      pointerEvents: "none",
      height: "15rem",
      backgroundColor: theme.customColors.black,
      position: "fixed",
      zIndex: 999,
      boxShadow: "0 0.1px 11px 2px rgba(68,89,88,.11)",
      top: "0",
    },
    toolbarContainer: {
      height: "70px",
      transition: "height 1s ease-in-out",
      backgroundColor: theme.customColors.black,
      position: "fixed",
      zIndex: 9999,
      boxShadow: "0 0.1px 11px 2px rgba(68,89,88,.11)",
      top: "0",
    },
    appBar: {
      height: "0 !important",
      borderBottom: "3px solid " + theme.customColors.secondary,
      maxWidth: "100%",
      display: "contents !important",
      "& .MuiContainer-root": {
        padding: "0 !important",
      },
    },
    toolbar: {
      height: "100% !important",
      minHeight: "100% !important",
    },
    menuTitle: {
      color: "#000 !important",
      fontSize:
        window.innerWidth > 1000 ? "14px !important" : "12px !important",
      "& :hover": {
        background: "none !important",
        backgroundColor: "none !important",
      },
      "& >div": {
        marginRight: "auto !important",
        marginLeft: "auto !important",
      },
    },
    logoContainer: {
      display: "table-cell",
      verticalAlign: "middle",
      width: "116px",
      height: "27px",
    },
    menuRoot: {
      "& .MuiPaper-root": {
        background: "white !important",
        // opacity: '60% !important',
        width: "200px",
        color:
          localStorage.getItem("themeType") === "light"
            ? theme.customColors.main
            : "white",
        // borderRadius: "10px",
      },
      "& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded ": {
        marginRight: "-90px",
      },
    },
    menuItem: {
      color: "#000",
      fontSize: "15px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      letterSpacing: "0.03px",
      opacity: "100% !important",
      // background: theme.customColors.childBack + " !important",
      borderRadius: "5px !important",
      padding: "2px !important",
      paddingLeft: "10px !important",
      width: "100%",
      display: "table",
      height: "35px",
      textDecoration: "none",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "transparent !important",
      },
    },
    title: {
      "&:hover": {
        fontWeight: "bold",
      },
    },
    profileMenu: {
      "& .MuiList-root.MuiList-padding": {
        paddingTop: "0 !important",
        paddingBottom: "0 !important",
        zIndex: 9999999,
        // borderRadius: "10px",
      },
    },
    box: {
      background: "transparent !important",
      backgroundColor: "transparent !important",
      "& .MuiPaper-root.MuiPaper-elevation": {
        background: "transparent !important",
        backgroundColor: "transparent !important",
        borderRadius: "10px !important",
      },
      "& .MuiTypography-root": {
        color: theme.customColors.childBack + " !important",
      },
    },
    menuContainer: {
      textAlign: "center",
      width: "auto",
      height: "100%",
      display: "table",
      paddingRight: "10px",
      paddingLeft: "10px",
    },
    menuContainerServices: {
      borderTopLeftRadius: "40px",
      borderBottomLeftRadius: "40px",
      textAlign: "center",
      width: "auto",
      height: "100%",
      display: "table",
      padding: "0",
      "& li": {
        display: "table-cell",
        verticalAlign: "middle",
      },
    },
    link: {
      color: theme.customColors.main,
      textDecoration: "none",
      border: "1px solid " + theme.customColors.main,
      "&:hover": {
        color: theme.customColors.main,
        fontWeight: "bold",
      },
    },
    signUpCntnr: {
      color: theme.customColors.childBack,
      width: "68px",
      height: "32px",
      flexShrink: 0,
      borderRadius: "8px",
      // border: '1px solid' + theme.customColors.main,
      display: "table",
    },
    signUpCntnrSm: {
      color: theme.customColors.main,
      width: "60px",
      height: "25px",
      flexShrink: 0,
      borderRadius: "8px",
      border: "1px solid" + theme.customColors.main,
      display: "table",
    },
    xsUserName: {
      color: theme.customColors.title + " !important",
      verticalAlign: "middle",
      padding: "0",
      fontSize: "16px !important",
    },
    loginCntnr: {
      width: "auto",
      height: "32px",
      flexShrink: 0,
      borderRadius: "8px",
      // background: '#2D3CD7',
      display: "flex",
      justifyContent: "center",
    },
    loginCntnrSm: {
      width: "60px",
      height: "25px",
      flexShrink: 0,
      borderRadius: "8px",
      background: "#2D3CD7",
      display: "table",
    },
    loginLine: {
      width: "2px",
      height: "34px",
      background: "#bcbcbc",
      padding: "0",
    },
    signUp: {
      pointerEvents: "visible",
      color: "#bcbcbc !important",
      textAlign: "center",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      display: "table-cell",
      verticalAlign: "middle",
      cursor: "pointer",
      "& .MuiTypography-root": {
        color: theme.customColors.childBack + " !important",
      },
      "&:hover": {
        background: "none !important",
        color: "white !important",
        transition: "color 0.5s ease-in-out",
        fontWeight: 900,
      },
    },
    login: {
      pointerEvents: "visible",
      color: "#bcbcbc !important",
      textAlign: "center",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "24px",
      display: "table-cell",
      verticalAlign: "middle",
      "&:hover": {
        background: "none !important",
        color: "white !important",
        transition: "color 0.5s ease-in-out",
        fontWeight: 900,
      },
    },
    signUpSm: {
      color: theme.customColors.main + " !important",
      textAlign: "center",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      display: "table-cell",
      verticalAlign: "middle",
      cursor: "pointer",
      "&:hover": {
        background: "none !important",
      },
    },
    loginSm: {
      color: theme.customColors.childBack,
      textAlign: "center",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      display: "table-cell",
      verticalAlign: "middle",
      "&:hover": {
        background: "none !important",
      },
    },
    menuTtl: {
      color: theme.customColors.childBack + " !important",
      fontSize:
        window.innerWidth > 1200 ? "15px !important" : "12px !important",
      "& :hover": {
        background: "none !important",
        backgroundColor: "none !important",
      },
      // fontWeight: 700,
      textDecoration: "none",
      width: "auto",
      display: "table-cell",
      verticalAlign: "middle",
      cursor: "pointer",
      fontWeight: 700,
    },
    menuTtlSlctd: {
      color: "#000 !important",
      fontSize:
        window.innerWidth > 1200 ? "15px !important" : "12px !important",
      "& :hover": {
        background: "none !important",
        backgroundColor: "none !important",
      },
      fontWeight: 700,
      textDecoration: "none",
      width: "auto",
      display: "table-cell",
      verticalAlign: "middle",
      cursor: "pointer",
    },
    gidCntnr: {
      color: "#bcbcbc !important",
      fontSize:
        window.innerWidth > 1200 ? "14px !important" : "12px !important",
      fontWeight: 700,
      textDecoration: "none",
      width: "auto",
      // display: 'table-cell',
      // verticalAlign: 'middle',
      cursor: "pointer",
      "&:hover": {
        color: "white !important",
        transition: "color 0.5s ease-in-out",
        fontWeight: 900,
      },
    },
    gud: {
      // backgroundColor: theme.customColors.dark,
      borderRadius: "5px",
      paddingRight: "8px",
      paddingLeft: "8px",
      pointerEvents: "visible",
    },
    navigationTop: {
      height: "70px",
      backgroundColor: "#000000b5",
      position: "absolute",
      zIndex: 999,
      boxShadow: "0 0.1px 11px 2px rgba(68,89,88,.11)",
      top: "15rem",
      width: "100%",
      "& ul": {
        listStyleType: "none",
      },
    },
    navigation: {
      height: "70px",
      backgroundColor: "#000000d4",
      position: "fixed",
      zIndex: 999,
      boxShadow: "0 0.1px 11px 2px rgba(68,89,88,.11)",
      top: "70px",
      width: "100%",
      "& ul": {
        listStyleType: "none",
      },
    },
    logo: {
      cursor: "pointer",
      width: "45px",
      height: "32px",
      transition: "height 1s, width 1s",
    },
    logoTop: {
      cursor: "pointer",
      width: "100px",
      height: "71px",
      transition: "height 1s, width 1s",
    },
    "@keyframes fadeInAnimation": {
      "0%": {
        opacity: "0",
      },
      "100%": {
        opacity: "1",
      },
    },
    logoMotion: {
      animation: "$fadeInAnimation ease 5s",
      animationIterationCount: 1,
      animationFillMode: "forwards",
    },
  })
);
